import { ShiftRequestStatusEnum } from '@umss/shared/utils';

/**
 * Urgent shift alert for dashboard display
 */
export interface UrgentShift {
  id: string;
  facilityId: string;
  facilityName: string;
  facilityLocation?: string; // Formatted: "City, ST"
  facilityFullAddress?: string; // Full address for modal display
  distanceMiles?: number; // Distance from contractor location
  facilitySubtypeName?: string; // Department name (e.g., "Cardiac ICU")
  scopeOfPractice?: string;
  scopeOfPracticeDisplay?: string;
  shiftDate: string; // Original YYYY-MM-DD format
  date: string; // Formatted: "Wednesday, Sept 17"
  startTime: string; // HH:mm:ss format
  endTime: string;
  hourlyRate: number;
  percentage: string; // Formatted: "20% higher rate"
  message: string;
  expiresAt?: string; // ISO datetime when the urgent shift expires
}

/**
 * Pay period statistics for dashboard display
 */
export interface PayPeriodStats {
  hoursWorked: number;
  estimatedGrossPay: number;
  hoursScheduled: number;
}

/**
 * Shift request for dashboard display
 */
export interface ShiftRequest {
  id: string;
  facilityName: string;
  location: string;
  date: string; // Formatted: "Sep 17"
  dayOfWeek: string; // "Wednesday"
  startTime: string; // "19:00" or "7:00 PM"
  endTime: string;
  shiftNeedId: string;
  facilityId: string;
  facilitySubtypeName?: string; // Department name
  distanceMiles?: number; // Distance from contractor location
  scopeOfPractice: number;
  scopeOfPracticeDisplay: string;
  hourlyRate: number;
  latestCounterOfferRate?: number | null;
  estimatedHours: number;
  estimatedPayment: number;
  status: string;
  shiftDate: string; // Original YYYY-MM-DD format
}

/**
 * Upcoming shift for dashboard display
 * Simplified view model with formatted display properties
 */
export interface UpcomingShift {
  id: string;
  facilityId: string;
  facilityName: string;
  facilityFullAddress?: string;
  facilitySubtypeName?: string; // Department name
  distanceMiles?: number; // Distance from contractor location
  contractorId: string;
  contractorName: string;
  scopeOfPractice: number;
  scopeOfPracticeDisplay: string;
  shiftType: number;
  shiftTypeDisplay: string;
  shiftDate: string;
  startTime: string;
  endTime: string;
  hourlyRate: number;
  specialInstructions?: string;
  status: ShiftRequestStatusEnum;
  statusDisplay: string;
  confirmedAt?: string;
  confirmedByName?: string;
  estimatedHours: number;
  estimatedPayment: number;
}
